import React from "react";

const LegendLine = ({colour, width = 20, height = 4}: {
  colour: string,
  width?: number | string,
  height?: number | string
}) => {
  return (
    <span
      style={{
        display: "inline-block",
        width,
        height,
        backgroundColor: colour,
        marginRight: "0.5rem",
      }}
    />
  );
};
export default LegendLine;